import { Length, ModelBase, NormalLength, Property } from '@skylab-shared/core';
import { OrderShipmentMethodKind } from './common/order-shipment-method-kind';

export class OrderDeliveryShippmentMethodModel extends ModelBase {
	@Property()
	public kind: OrderShipmentMethodKind;

	@Property()
	public serviceId: string;

	@Property()
	@Length({ max: NormalLength }, 'data-model.orders.delivery.validation.service-name.length')
	public serviceName: string;
}
